import { useTranslation } from "@vixi/localization";
import { ButtonLink, Img, useGoBack } from "@vixi/ui";
import { Course } from "@vixi/types";

interface CourseCreatedStepProps {
  courseId?: Course["id"];
}

export const CourseCreatedStep = (props: CourseCreatedStepProps) => {
  useGoBack(null);
  const { t, tFile, byLocale } = useTranslation();

  return (
    <div className="relative m-auto w-118.25">
      <Img contain src={tFile("/images", "bubble-course-created.png")} className="w-full" />

      <ButtonLink
        variant="contained"
        to={props.courseId ? ("/courses/$courseId" as const) : ("/courses" as const)}
        params={{ courseId: props.courseId }}
        size="medium"
        className="ar:bottom-25 absolute bottom-5 left-5"
      >
        {t("Action.GoToCourse")}
      </ButtonLink>
    </div>
  );
};
